export default __webpack_public_path__ + "static/media/7-NikauSunrise.d935e76e.jpeg";